<div class="tab-content">

    <div class="hero-text" style="margin-left: 10px;">
        <h1 style="font-weight: 800;">{{'MENU_ADDITION_FORM'|translate}}</h1>
    </div>

    <mat-horizontal-stepper linear #stepper>
        <mat-step>
            <ng-template matStepLabel>Admin</ng-template>

            <div class="card-body table-responsive  mb-4">
                <mat-card style="border: 1px black solid;">
                    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
                        <div class="col">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="row">
                                        <div class="col">
                                            <div class="py-12" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                <button mat-button (click)="selectAdminAll()">
                                                    {{'SELECT_ALL'|translate}}</button>
                                                <button mat-button (click)="deAdminSelectAll()">
                                                    {{'REMOVE_ALL'|translate}}</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <hr class="mt-0">
                                        </div>
                                    </div>
        
                                    <div class="row">
                                        <div class="col-12 thin-scroll" style="max-height: 360px; overflow: auto;">
                                            <div class="row col-12">
                                                <div *ngFor="let menuItem of adminForMenus; let i = index">
                                                    <div *ngIf="menuItem.parentId==1">
                                                        <mat-checkbox name="menuitem-a-{{i}}" [(ngModel)]="menuItem.checked"
                                                            [indeterminate]="indeterminateMenu(menuItem)"
                                                            (change)="selectMenu(menuItem)">
                                                            <h2>{{menuItem.title|translate}}</h2>
                                                        </mat-checkbox>
                                                    </div>
                                                    <div *ngFor="let item of menuItem.children;let j = index"
                                                        class="col-4 pl-20">
                                                        <mat-checkbox *ngIf="item.parentId!=1 && item.parentId!=null"
                                                            name="menuitem-a-{{i}}-{{j}}" [(ngModel)]="item.checked"
                                                            (ngModelChange)="updateAllComplete(menuItem)">
                                                            <span class="text-small">{{item.title|translate}}</span>
                                                        </mat-checkbox>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                        </div>
                    </form>
                    <mat-progress-bar *ngIf="isLoading" class="form-progress-bar" [mode]="'indeterminate'">
                    </mat-progress-bar>
                </mat-card>
            </div>

            <div>
              <button mat-button matStepperPrevious>{{'BACK'|translate}}</button>
              <button mat-button matStepperNext>{{'NEXT'|translate}}</button>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Driver</ng-template>

            <div class="card-body table-responsive  mb-4">
                <mat-card style="border: 1px black solid;">
                    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
                        <div class="col">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="row">
                                        <div class="col">
                                            <div class="py-12" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                <button mat-button (click)="selectDriverAll()">
                                                    {{'SELECT_ALL'|translate}}</button>
                                                <button mat-button (click)="deDriverSelectAll()">
                                                    {{'REMOVE_ALL'|translate}}</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <hr class="mt-0">
                                        </div>
                                    </div>
        
                                    <div class="row">
                                        <div class="col-12 thin-scroll" style="max-height: 360px; overflow: auto;">
                                            <div class="row col-12">
                                                <div *ngFor="let menuItem of driverForMenus; let i = index">
                                                    <div *ngIf="menuItem.parentId==1">
                                                        <mat-checkbox name="menuitem-d-{{i}}" [(ngModel)]="menuItem.checked"
                                                            [indeterminate]="indeterminateMenu(menuItem)"
                                                            (change)="selectMenu(menuItem)">
                                                            <h2>{{menuItem.title|translate}}</h2>
                                                        </mat-checkbox>
                                                    </div>
                                                    <div *ngFor="let item of menuItem.children;let j = index"
                                                        class="col-4 pl-20">
                                                        <mat-checkbox *ngIf="item.parentId!=1 && item.parentId!=null"
                                                            name="menuitem-d-{{i}}-{{j}}" [(ngModel)]="item.checked"
                                                            (ngModelChange)="updateAllComplete(menuItem)">
                                                            <span class="text-small">{{item.title|translate}}</span>
                                                        </mat-checkbox>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                        </div>
                    </form>
                    <mat-progress-bar *ngIf="isLoading" class="form-progress-bar" [mode]="'indeterminate'">
                    </mat-progress-bar>
                </mat-card>
            </div>

            <div>
              <button mat-button matStepperPrevious>{{'BACK'|translate}}</button>
              <button mat-button matStepperNext>{{'NEXT'|translate}}</button>
            </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Personel</ng-template>

          <div class="card-body table-responsive  mb-4">
            <mat-card style="border: 1px black solid;">
                <form #form="ngForm" class="form container-fluid pl-0 pr-0">
                    <div class="col">
                        <div class="row">
                            <div class="col p-0">
                                <div class="row">
                                    <div class="col">
                                        <div class="py-12" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                            <button mat-button (click)="selectPersonelAll()">
                                                {{'SELECT_ALL'|translate}}</button>
                                            <button mat-button (click)="dePersonelSelectAll()">
                                                {{'REMOVE_ALL'|translate}}</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <hr class="mt-0">
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col-12 thin-scroll" style="max-height: 360px; overflow: auto;">
                                        <div class="row col-12">
                                            <div *ngFor="let menuItem of personelForMenus; let i = index">
                                                <div *ngIf="menuItem.parentId==1">
                                                    <mat-checkbox name="menuitem-p-{{i}}" [(ngModel)]="menuItem.checked"
                                                        [indeterminate]="indeterminateMenu(menuItem)"
                                                        (change)="selectMenu(menuItem)">
                                                        <h2>{{menuItem.title|translate}}</h2>
                                                    </mat-checkbox>
                                                </div>
                                                <div *ngFor="let item of menuItem.children;let j = index"
                                                    class="col-4 pl-20">
                                                    <mat-checkbox *ngIf="item.parentId!=1 && item.parentId!=null"
                                                        name="menuitem-p-{{i}}-{{j}}" [(ngModel)]="item.checked"
                                                        (ngModelChange)="updateAllComplete(menuItem)">
                                                        <span class="text-small">{{item.title|translate}}</span>
                                                    </mat-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </form>
                <mat-progress-bar *ngIf="isLoading" class="form-progress-bar" [mode]="'indeterminate'">
                </mat-progress-bar>
            </mat-card>
        </div>

          <div>
            <button mat-button matStepperPrevious>{{'BACK'|translate}}</button>
            <button mat-button (click)="save()">{{'CREATE'|translate}}</button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
</div>